// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,ts_nocheck
// @generated from protobuf file "agency/telemetry/v1/telemetry.proto" (package "agency.telemetry.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { NodeID } from "../../address/v1/address";
import { Timestamp } from "../../../google/protobuf/timestamp";
/**
 * SpanEvent represents an OpenTelemetry span event.
 *
 * @generated from protobuf message agency.telemetry.v1.SpanEvent
 */
export interface SpanEvent {
    /**
     * trace_id is the W3C trace ID.
     *
     * @generated from protobuf field: string trace_id = 1
     */
    traceId: string;
    /**
     * span_id is the W3C span ID.
     *
     * @generated from protobuf field: string span_id = 2
     */
    spanId: string;
    /**
     * parent_span_id is the parent span ID (optional).
     *
     * @generated from protobuf field: string parent_span_id = 3
     */
    parentSpanId: string;
    /**
     * name is the span operation name.
     *
     * @generated from protobuf field: string name = 4
     */
    name: string;
    /**
     * kind is the span kind.
     *
     * @generated from protobuf field: agency.telemetry.v1.SpanKind kind = 5
     */
    kind: SpanKind;
    /**
     * start_time is when the span started.
     *
     * @generated from protobuf field: google.protobuf.Timestamp start_time = 6
     */
    startTime?: Timestamp;
    /**
     * end_time is when the span ended.
     *
     * @generated from protobuf field: google.protobuf.Timestamp end_time = 7
     */
    endTime?: Timestamp;
    /**
     * status is the span completion status.
     *
     * @generated from protobuf field: agency.telemetry.v1.SpanStatus status = 8
     */
    status?: SpanStatus;
    /**
     * attributes are span metadata.
     *
     * @generated from protobuf field: map<string, string> attributes = 9
     */
    attributes: {
        [key: string]: string;
    };
    /**
     * events are timestamped span events.
     *
     * @generated from protobuf field: repeated agency.telemetry.v1.SpanEventRecord events = 10
     */
    events: SpanEventRecord[];
    /**
     * links are links to other spans.
     *
     * @generated from protobuf field: repeated agency.telemetry.v1.SpanLink links = 11
     */
    links: SpanLink[];
    /**
     * resource attributes identify the originating resource.
     *
     * @generated from protobuf field: map<string, string> resource_attributes = 12
     */
    resourceAttributes: {
        [key: string]: string;
    };
}
/**
 * Trace represents a complete distributed trace with all spans.
 *
 * @generated from protobuf message agency.telemetry.v1.Trace
 */
export interface Trace {
    /**
     * trace_id is the W3C trace ID.
     *
     * @generated from protobuf field: string trace_id = 1
     */
    traceId: string;
    /**
     * spans are all spans in this trace.
     *
     * @generated from protobuf field: repeated agency.telemetry.v1.SpanEvent spans = 2
     */
    spans: SpanEvent[];
    /**
     * start_time is when the trace started (earliest span start).
     *
     * @generated from protobuf field: google.protobuf.Timestamp start_time = 3
     */
    startTime?: Timestamp;
    /**
     * end_time is when the trace ended (latest span end).
     *
     * @generated from protobuf field: google.protobuf.Timestamp end_time = 4
     */
    endTime?: Timestamp;
    /**
     * duration_ms is the total trace duration.
     *
     * @generated from protobuf field: int64 duration_ms = 5
     */
    durationMs: bigint;
    /**
     * root_span_id is the root span identifier.
     *
     * @generated from protobuf field: string root_span_id = 6
     */
    rootSpanId: string;
    /**
     * service_name is the originating service.
     *
     * @generated from protobuf field: string service_name = 7
     */
    serviceName: string;
    /**
     * tenant is the tenant context.
     *
     * @generated from protobuf field: string tenant = 8
     */
    tenant: string;
    /**
     * workspace is the workspace context.
     *
     * @generated from protobuf field: string workspace = 9
     */
    workspace: string;
    /**
     * session_id is the session context.
     *
     * @generated from protobuf field: string session_id = 10
     */
    sessionId: string;
    /**
     * status is the overall trace status (derived from spans).
     *
     * @generated from protobuf field: agency.telemetry.v1.SpanStatus status = 11
     */
    status?: SpanStatus;
    /**
     * metadata contains additional trace context.
     *
     * @generated from protobuf field: map<string, string> metadata = 12
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * SpanStatus represents span completion status.
 *
 * @generated from protobuf message agency.telemetry.v1.SpanStatus
 */
export interface SpanStatus {
    /**
     * code is the status code.
     *
     * @generated from protobuf field: agency.telemetry.v1.SpanStatusCode code = 1
     */
    code: SpanStatusCode;
    /**
     * message provides additional status context.
     *
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * SpanEventRecord represents a timestamped event within a span.
 *
 * @generated from protobuf message agency.telemetry.v1.SpanEventRecord
 */
export interface SpanEventRecord {
    /**
     * name is the event name.
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * timestamp is when the event occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 2
     */
    timestamp?: Timestamp;
    /**
     * attributes are event metadata.
     *
     * @generated from protobuf field: map<string, string> attributes = 3
     */
    attributes: {
        [key: string]: string;
    };
}
/**
 * SpanLink links to another span.
 *
 * @generated from protobuf message agency.telemetry.v1.SpanLink
 */
export interface SpanLink {
    /**
     * trace_id is the linked trace ID.
     *
     * @generated from protobuf field: string trace_id = 1
     */
    traceId: string;
    /**
     * span_id is the linked span ID.
     *
     * @generated from protobuf field: string span_id = 2
     */
    spanId: string;
    /**
     * attributes are link metadata.
     *
     * @generated from protobuf field: map<string, string> attributes = 3
     */
    attributes: {
        [key: string]: string;
    };
}
/**
 * Metric represents a telemetry metric.
 *
 * @generated from protobuf message agency.telemetry.v1.Metric
 */
export interface Metric {
    /**
     * name is the metric name.
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * type is the metric type.
     *
     * @generated from protobuf field: agency.telemetry.v1.MetricType type = 2
     */
    type: MetricType;
    /**
     * value is the metric value.
     *
     * @generated from protobuf field: double value = 3
     */
    value: number;
    /**
     * timestamp is when the metric was recorded.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 4
     */
    timestamp?: Timestamp;
    /**
     * labels are metric dimensions.
     *
     * @generated from protobuf field: map<string, string> labels = 5
     */
    labels: {
        [key: string]: string;
    };
    /**
     * unit is the measurement unit.
     *
     * @generated from protobuf field: string unit = 6
     */
    unit: string;
    /**
     * description explains the metric.
     *
     * @generated from protobuf field: string description = 7
     */
    description: string;
}
/**
 * HarnessEvent represents a harness lifecycle or operational event.
 *
 * @generated from protobuf message agency.telemetry.v1.HarnessEvent
 */
export interface HarnessEvent {
    /**
     * harness_id identifies the harness instance.
     *
     * @generated from protobuf field: string harness_id = 1
     */
    harnessId: string;
    /**
     * event_type classifies the event.
     *
     * @generated from protobuf field: agency.telemetry.v1.HarnessEventType event_type = 2
     */
    eventType: HarnessEventType;
    /**
     * severity indicates the event importance.
     *
     * @generated from protobuf field: agency.telemetry.v1.EventSeverity severity = 3
     */
    severity: EventSeverity;
    /**
     * message describes the event.
     *
     * @generated from protobuf field: string message = 4
     */
    message: string;
    /**
     * timestamp is when the event occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp timestamp = 5
     */
    timestamp?: Timestamp;
    /**
     * node identifies the node if applicable.
     *
     * @generated from protobuf field: agency.address.v1.NodeID node = 6
     */
    node?: NodeID;
    /**
     * metadata contains additional event context.
     *
     * @generated from protobuf field: map<string, string> metadata = 7
     */
    metadata: {
        [key: string]: string;
    };
}
/**
 * AlertEvent represents an alert notification.
 *
 * @generated from protobuf message agency.telemetry.v1.AlertEvent
 */
export interface AlertEvent {
    /**
     * alert_id uniquely identifies this alert instance.
     *
     * @generated from protobuf field: string alert_id = 1
     */
    alertId: string;
    /**
     * rule_id identifies the alert rule that triggered.
     *
     * @generated from protobuf field: string rule_id = 2
     */
    ruleId: string;
    /**
     * severity indicates the alert severity.
     *
     * @generated from protobuf field: agency.telemetry.v1.EventSeverity severity = 3
     */
    severity: EventSeverity;
    /**
     * title is the alert title.
     *
     * @generated from protobuf field: string title = 4
     */
    title: string;
    /**
     * description provides alert details.
     *
     * @generated from protobuf field: string description = 5
     */
    description: string;
    /**
     * fired_at is when the alert fired.
     *
     * @generated from protobuf field: google.protobuf.Timestamp fired_at = 6
     */
    firedAt?: Timestamp;
    /**
     * resolved indicates if the alert is resolved.
     *
     * @generated from protobuf field: bool resolved = 7
     */
    resolved: boolean;
    /**
     * resolved_at is when the alert was resolved (if applicable).
     *
     * @generated from protobuf field: google.protobuf.Timestamp resolved_at = 8
     */
    resolvedAt?: Timestamp;
    /**
     * labels are alert dimensions for routing/grouping.
     *
     * @generated from protobuf field: map<string, string> labels = 9
     */
    labels: {
        [key: string]: string;
    };
    /**
     * annotations provide additional context.
     *
     * @generated from protobuf field: map<string, string> annotations = 10
     */
    annotations: {
        [key: string]: string;
    };
}
/**
 * RevocationEvent signals credential or key revocation.
 *
 * @generated from protobuf message agency.telemetry.v1.RevocationEvent
 */
export interface RevocationEvent {
    /**
     * entity_id is the revoked entity identifier.
     *
     * @generated from protobuf field: string entity_id = 1
     */
    entityId: string;
    /**
     * revocation_type indicates what was revoked.
     *
     * @generated from protobuf field: agency.telemetry.v1.RevocationType revocation_type = 2
     */
    revocationType: RevocationType;
    /**
     * tenant scopes the revocation (optional).
     *
     * @generated from protobuf field: string tenant = 3
     */
    tenant: string;
    /**
     * reason explains the revocation.
     *
     * @generated from protobuf field: string reason = 4
     */
    reason: string;
    /**
     * revoked_at is when the revocation occurred.
     *
     * @generated from protobuf field: google.protobuf.Timestamp revoked_at = 5
     */
    revokedAt?: Timestamp;
    /**
     * revoked_by identifies who triggered the revocation.
     *
     * @generated from protobuf field: string revoked_by = 6
     */
    revokedBy: string;
}
/**
 * ExportRequest is a batch of metrics for export.
 *
 * @generated from protobuf message agency.telemetry.v1.ExportRequest
 */
export interface ExportRequest {
    /**
     * batch_id uniquely identifies this export batch.
     *
     * @generated from protobuf field: string batch_id = 1
     */
    batchId: string;
    /**
     * metrics are the metrics to export.
     *
     * @generated from protobuf field: repeated agency.telemetry.v1.Metric metrics = 2
     */
    metrics: Metric[];
    /**
     * export_format is the target format (prometheus, statsd, influx, graphite).
     *
     * @generated from protobuf field: string export_format = 3
     */
    exportFormat: string;
    /**
     * exported_at is when this batch was exported.
     *
     * @generated from protobuf field: google.protobuf.Timestamp exported_at = 4
     */
    exportedAt?: Timestamp;
}
/**
 * ExportResponse confirms metrics export completion.
 *
 * @generated from protobuf message agency.telemetry.v1.ExportResponse
 */
export interface ExportResponse {
    /**
     * batch_id identifies the exported batch.
     *
     * @generated from protobuf field: string batch_id = 1
     */
    batchId: string;
    /**
     * metrics_exported is the count of successfully exported metrics.
     *
     * @generated from protobuf field: int32 metrics_exported = 2
     */
    metricsExported: number;
    /**
     * metrics_failed is the count of failed exports.
     *
     * @generated from protobuf field: int32 metrics_failed = 3
     */
    metricsFailed: number;
    /**
     * export_endpoint is where the metrics were sent.
     *
     * @generated from protobuf field: string export_endpoint = 4
     */
    exportEndpoint: string;
    /**
     * exported_at is when the export completed.
     *
     * @generated from protobuf field: google.protobuf.Timestamp exported_at = 5
     */
    exportedAt?: Timestamp;
}
/**
 * HealthCheckRequest checks metrics backend connectivity.
 *
 * @generated from protobuf message agency.telemetry.v1.HealthCheckRequest
 */
export interface HealthCheckRequest {
    /**
     * endpoint is the metrics endpoint to check.
     *
     * @generated from protobuf field: string endpoint = 1
     */
    endpoint: string;
}
/**
 * HealthCheckResponse returns metrics backend health status.
 *
 * @generated from protobuf message agency.telemetry.v1.HealthCheckResponse
 */
export interface HealthCheckResponse {
    /**
     * healthy indicates if the metrics backend is reachable.
     *
     * @generated from protobuf field: bool healthy = 1
     */
    healthy: boolean;
    /**
     * latency_ms is the connection latency.
     *
     * @generated from protobuf field: int64 latency_ms = 2
     */
    latencyMs: bigint;
    /**
     * error_message describes any connection issues.
     *
     * @generated from protobuf field: string error_message = 3
     */
    errorMessage: string;
}
/**
 * SpanKind classifies spans by their role.
 *
 * @generated from protobuf enum agency.telemetry.v1.SpanKind
 */
export enum SpanKind {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: SPAN_KIND_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * INTERNAL represents internal operations.
     *
     * @generated from protobuf enum value: SPAN_KIND_INTERNAL = 1;
     */
    INTERNAL = 1,
    /**
     * SERVER represents server-side request handling.
     *
     * @generated from protobuf enum value: SPAN_KIND_SERVER = 2;
     */
    SERVER = 2,
    /**
     * CLIENT represents client-side requests.
     *
     * @generated from protobuf enum value: SPAN_KIND_CLIENT = 3;
     */
    CLIENT = 3,
    /**
     * PRODUCER represents message producers.
     *
     * @generated from protobuf enum value: SPAN_KIND_PRODUCER = 4;
     */
    PRODUCER = 4,
    /**
     * CONSUMER represents message consumers.
     *
     * @generated from protobuf enum value: SPAN_KIND_CONSUMER = 5;
     */
    CONSUMER = 5
}
/**
 * SpanStatusCode represents the span outcome.
 *
 * @generated from protobuf enum agency.telemetry.v1.SpanStatusCode
 */
export enum SpanStatusCode {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: SPAN_STATUS_CODE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * OK indicates success.
     *
     * @generated from protobuf enum value: SPAN_STATUS_CODE_SPAN_STATUS_OK = 1;
     */
    SPAN_STATUS_OK = 1,
    /**
     * ERROR indicates failure.
     *
     * @generated from protobuf enum value: SPAN_STATUS_CODE_SPAN_STATUS_ERROR = 2;
     */
    SPAN_STATUS_ERROR = 2
}
/**
 * MetricType classifies metrics.
 *
 * @generated from protobuf enum agency.telemetry.v1.MetricType
 */
export enum MetricType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: METRIC_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * COUNTER is a monotonically increasing counter.
     *
     * @generated from protobuf enum value: METRIC_TYPE_COUNTER = 1;
     */
    COUNTER = 1,
    /**
     * GAUGE is a value that can increase or decrease.
     *
     * @generated from protobuf enum value: METRIC_TYPE_GAUGE = 2;
     */
    GAUGE = 2,
    /**
     * HISTOGRAM represents a distribution of values.
     *
     * @generated from protobuf enum value: METRIC_TYPE_HISTOGRAM = 3;
     */
    HISTOGRAM = 3,
    /**
     * SUMMARY represents quantiles over a sliding window.
     *
     * @generated from protobuf enum value: METRIC_TYPE_SUMMARY = 4;
     */
    SUMMARY = 4
}
/**
 * HarnessEventType classifies harness events.
 *
 * @generated from protobuf enum agency.telemetry.v1.HarnessEventType
 */
export enum HarnessEventType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: HARNESS_EVENT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * STARTUP indicates harness startup.
     *
     * @generated from protobuf enum value: HARNESS_EVENT_TYPE_STARTUP = 1;
     */
    STARTUP = 1,
    /**
     * SHUTDOWN indicates harness shutdown.
     *
     * @generated from protobuf enum value: HARNESS_EVENT_TYPE_SHUTDOWN = 2;
     */
    SHUTDOWN = 2,
    /**
     * READY indicates harness is ready to serve.
     *
     * @generated from protobuf enum value: HARNESS_EVENT_TYPE_READY = 3;
     */
    READY = 3,
    /**
     * DRAINING indicates graceful drain started.
     *
     * @generated from protobuf enum value: HARNESS_EVENT_TYPE_DRAINING = 4;
     */
    DRAINING = 4,
    /**
     * SUPERVISION_EXHAUSTED indicates supervision restart limit reached.
     *
     * @generated from protobuf enum value: HARNESS_EVENT_TYPE_SUPERVISION_EXHAUSTED = 5;
     */
    SUPERVISION_EXHAUSTED = 5,
    /**
     * NATS_CONNECTED indicates NATS connection established.
     *
     * @generated from protobuf enum value: HARNESS_EVENT_TYPE_NATS_CONNECTED = 6;
     */
    NATS_CONNECTED = 6,
    /**
     * NATS_DISCONNECTED indicates NATS connection lost.
     *
     * @generated from protobuf enum value: HARNESS_EVENT_TYPE_NATS_DISCONNECTED = 7;
     */
    NATS_DISCONNECTED = 7,
    /**
     * CIRCUIT_OPENED indicates circuit breaker opened.
     *
     * @generated from protobuf enum value: HARNESS_EVENT_TYPE_CIRCUIT_OPENED = 8;
     */
    CIRCUIT_OPENED = 8,
    /**
     * CIRCUIT_CLOSED indicates circuit breaker closed.
     *
     * @generated from protobuf enum value: HARNESS_EVENT_TYPE_CIRCUIT_CLOSED = 9;
     */
    CIRCUIT_CLOSED = 9,
    /**
     * ACTOR_SPAWN_FAILED indicates actor creation failure.
     *
     * @generated from protobuf enum value: HARNESS_EVENT_TYPE_ACTOR_SPAWN_FAILED = 10;
     */
    ACTOR_SPAWN_FAILED = 10,
    /**
     * HOOK_TIMEOUT indicates hook execution timeout.
     *
     * @generated from protobuf enum value: HARNESS_EVENT_TYPE_HOOK_TIMEOUT = 11;
     */
    HOOK_TIMEOUT = 11,
    /**
     * CONFIG_RELOADED indicates configuration reload.
     *
     * @generated from protobuf enum value: HARNESS_EVENT_TYPE_CONFIG_RELOADED = 12;
     */
    CONFIG_RELOADED = 12
}
/**
 * EventSeverity indicates event importance.
 *
 * @generated from protobuf enum agency.telemetry.v1.EventSeverity
 */
export enum EventSeverity {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: EVENT_SEVERITY_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * DEBUG is for detailed diagnostic information.
     *
     * @generated from protobuf enum value: EVENT_SEVERITY_SEVERITY_DEBUG = 1;
     */
    SEVERITY_DEBUG = 1,
    /**
     * INFO is for informational messages.
     *
     * @generated from protobuf enum value: EVENT_SEVERITY_SEVERITY_INFO = 2;
     */
    SEVERITY_INFO = 2,
    /**
     * WARNING is for potentially problematic situations.
     *
     * @generated from protobuf enum value: EVENT_SEVERITY_SEVERITY_WARNING = 3;
     */
    SEVERITY_WARNING = 3,
    /**
     * ERROR is for error events.
     *
     * @generated from protobuf enum value: EVENT_SEVERITY_SEVERITY_ERROR = 4;
     */
    SEVERITY_ERROR = 4,
    /**
     * CRITICAL is for critical failures requiring immediate attention.
     *
     * @generated from protobuf enum value: EVENT_SEVERITY_SEVERITY_CRITICAL = 5;
     */
    SEVERITY_CRITICAL = 5
}
/**
 * RevocationType classifies revocations.
 *
 * @generated from protobuf enum agency.telemetry.v1.RevocationType
 */
export enum RevocationType {
    /**
     * UNSPECIFIED is the zero value and should not be used.
     *
     * @generated from protobuf enum value: REVOCATION_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * JWT revokes a JWT token.
     *
     * @generated from protobuf enum value: REVOCATION_TYPE_JWT = 1;
     */
    JWT = 1,
    /**
     * NKEY revokes an NKey.
     *
     * @generated from protobuf enum value: REVOCATION_TYPE_NKEY = 2;
     */
    NKEY = 2,
    /**
     * AGE_KEY revokes an AGE encryption key.
     *
     * @generated from protobuf enum value: REVOCATION_TYPE_AGE_KEY = 3;
     */
    AGE_KEY = 3,
    /**
     * CREDENTIAL revokes tool credentials.
     *
     * @generated from protobuf enum value: REVOCATION_TYPE_CREDENTIAL = 4;
     */
    CREDENTIAL = 4,
    /**
     * USER revokes all user credentials.
     *
     * @generated from protobuf enum value: REVOCATION_TYPE_USER = 5;
     */
    USER = 5,
    /**
     * SESSION revokes a session.
     *
     * @generated from protobuf enum value: REVOCATION_TYPE_SESSION = 6;
     */
    SESSION = 6
}
// @generated message type with reflection information, may provide speed optimized methods
class SpanEvent$Type extends MessageType<SpanEvent> {
    constructor() {
        super("agency.telemetry.v1.SpanEvent", [
            { no: 1, name: "trace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { len: "32", pattern: "^[0-9a-f]{32}$" } } } },
            { no: 2, name: "span_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { len: "16", pattern: "^[0-9a-f]{16}$" } } } },
            { no: 3, name: "parent_span_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { pattern: "^([0-9a-f]{16})?$" } } } },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 5, name: "kind", kind: "enum", T: () => ["agency.telemetry.v1.SpanKind", SpanKind, "SPAN_KIND_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 6, name: "start_time", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "end_time", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 8, name: "status", kind: "message", T: () => SpanStatus, options: { "buf.validate.field": { required: true } } },
            { no: 9, name: "attributes", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "100", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } },
            { no: 10, name: "events", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SpanEventRecord, options: { "buf.validate.field": { repeated: { maxItems: "100" } } } },
            { no: 11, name: "links", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SpanLink, options: { "buf.validate.field": { repeated: { maxItems: "50" } } } },
            { no: 12, name: "resource_attributes", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "1024" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SpanEvent>): SpanEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.traceId = "";
        message.spanId = "";
        message.parentSpanId = "";
        message.name = "";
        message.kind = 0;
        message.attributes = {};
        message.events = [];
        message.links = [];
        message.resourceAttributes = {};
        if (value !== undefined)
            reflectionMergePartial<SpanEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SpanEvent): SpanEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string trace_id */ 1:
                    message.traceId = reader.string();
                    break;
                case /* string span_id */ 2:
                    message.spanId = reader.string();
                    break;
                case /* string parent_span_id */ 3:
                    message.parentSpanId = reader.string();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* agency.telemetry.v1.SpanKind kind */ 5:
                    message.kind = reader.int32();
                    break;
                case /* google.protobuf.Timestamp start_time */ 6:
                    message.startTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startTime);
                    break;
                case /* google.protobuf.Timestamp end_time */ 7:
                    message.endTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endTime);
                    break;
                case /* agency.telemetry.v1.SpanStatus status */ 8:
                    message.status = SpanStatus.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* map<string, string> attributes */ 9:
                    this.binaryReadMap9(message.attributes, reader, options);
                    break;
                case /* repeated agency.telemetry.v1.SpanEventRecord events */ 10:
                    message.events.push(SpanEventRecord.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated agency.telemetry.v1.SpanLink links */ 11:
                    message.links.push(SpanLink.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, string> resource_attributes */ 12:
                    this.binaryReadMap12(message.resourceAttributes, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap9(map: SpanEvent["attributes"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SpanEvent["attributes"] | undefined, val: SpanEvent["attributes"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.telemetry.v1.SpanEvent.attributes");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    private binaryReadMap12(map: SpanEvent["resourceAttributes"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SpanEvent["resourceAttributes"] | undefined, val: SpanEvent["resourceAttributes"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.telemetry.v1.SpanEvent.resource_attributes");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: SpanEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string trace_id = 1; */
        if (message.traceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.traceId);
        /* string span_id = 2; */
        if (message.spanId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.spanId);
        /* string parent_span_id = 3; */
        if (message.parentSpanId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.parentSpanId);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* agency.telemetry.v1.SpanKind kind = 5; */
        if (message.kind !== 0)
            writer.tag(5, WireType.Varint).int32(message.kind);
        /* google.protobuf.Timestamp start_time = 6; */
        if (message.startTime)
            Timestamp.internalBinaryWrite(message.startTime, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_time = 7; */
        if (message.endTime)
            Timestamp.internalBinaryWrite(message.endTime, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* agency.telemetry.v1.SpanStatus status = 8; */
        if (message.status)
            SpanStatus.internalBinaryWrite(message.status, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> attributes = 9; */
        for (let k of globalThis.Object.keys(message.attributes))
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.attributes[k]).join();
        /* repeated agency.telemetry.v1.SpanEventRecord events = 10; */
        for (let i = 0; i < message.events.length; i++)
            SpanEventRecord.internalBinaryWrite(message.events[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated agency.telemetry.v1.SpanLink links = 11; */
        for (let i = 0; i < message.links.length; i++)
            SpanLink.internalBinaryWrite(message.links[i], writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> resource_attributes = 12; */
        for (let k of globalThis.Object.keys(message.resourceAttributes))
            writer.tag(12, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.resourceAttributes[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.telemetry.v1.SpanEvent
 */
export const SpanEvent = new SpanEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Trace$Type extends MessageType<Trace> {
    constructor() {
        super("agency.telemetry.v1.Trace", [
            { no: 1, name: "trace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { len: "32", pattern: "^[0-9a-f]{32}$" } } } },
            { no: 2, name: "spans", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SpanEvent, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "10000" } } } },
            { no: 3, name: "start_time", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 4, name: "end_time", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "duration_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 6, name: "root_span_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { len: "16", pattern: "^[0-9a-f]{16}$" } } } },
            { no: 7, name: "service_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 8, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 9, name: "workspace", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 10, name: "session_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "128", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 11, name: "status", kind: "message", T: () => SpanStatus, options: { "buf.validate.field": { required: true } } },
            { no: 12, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } }
        ]);
    }
    create(value?: PartialMessage<Trace>): Trace {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.traceId = "";
        message.spans = [];
        message.durationMs = 0n;
        message.rootSpanId = "";
        message.serviceName = "";
        message.tenant = "";
        message.workspace = "";
        message.sessionId = "";
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<Trace>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Trace): Trace {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string trace_id */ 1:
                    message.traceId = reader.string();
                    break;
                case /* repeated agency.telemetry.v1.SpanEvent spans */ 2:
                    message.spans.push(SpanEvent.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp start_time */ 3:
                    message.startTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.startTime);
                    break;
                case /* google.protobuf.Timestamp end_time */ 4:
                    message.endTime = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.endTime);
                    break;
                case /* int64 duration_ms */ 5:
                    message.durationMs = reader.int64().toBigInt();
                    break;
                case /* string root_span_id */ 6:
                    message.rootSpanId = reader.string();
                    break;
                case /* string service_name */ 7:
                    message.serviceName = reader.string();
                    break;
                case /* string tenant */ 8:
                    message.tenant = reader.string();
                    break;
                case /* string workspace */ 9:
                    message.workspace = reader.string();
                    break;
                case /* string session_id */ 10:
                    message.sessionId = reader.string();
                    break;
                case /* agency.telemetry.v1.SpanStatus status */ 11:
                    message.status = SpanStatus.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* map<string, string> metadata */ 12:
                    this.binaryReadMap12(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap12(map: Trace["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Trace["metadata"] | undefined, val: Trace["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.telemetry.v1.Trace.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: Trace, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string trace_id = 1; */
        if (message.traceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.traceId);
        /* repeated agency.telemetry.v1.SpanEvent spans = 2; */
        for (let i = 0; i < message.spans.length; i++)
            SpanEvent.internalBinaryWrite(message.spans[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp start_time = 3; */
        if (message.startTime)
            Timestamp.internalBinaryWrite(message.startTime, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp end_time = 4; */
        if (message.endTime)
            Timestamp.internalBinaryWrite(message.endTime, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int64 duration_ms = 5; */
        if (message.durationMs !== 0n)
            writer.tag(5, WireType.Varint).int64(message.durationMs);
        /* string root_span_id = 6; */
        if (message.rootSpanId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.rootSpanId);
        /* string service_name = 7; */
        if (message.serviceName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.serviceName);
        /* string tenant = 8; */
        if (message.tenant !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.tenant);
        /* string workspace = 9; */
        if (message.workspace !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.workspace);
        /* string session_id = 10; */
        if (message.sessionId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.sessionId);
        /* agency.telemetry.v1.SpanStatus status = 11; */
        if (message.status)
            SpanStatus.internalBinaryWrite(message.status, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> metadata = 12; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(12, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.telemetry.v1.Trace
 */
export const Trace = new Trace$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpanStatus$Type extends MessageType<SpanStatus> {
    constructor() {
        super("agency.telemetry.v1.SpanStatus", [
            { no: 1, name: "code", kind: "enum", T: () => ["agency.telemetry.v1.SpanStatusCode", SpanStatusCode, "SPAN_STATUS_CODE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } }
        ]);
    }
    create(value?: PartialMessage<SpanStatus>): SpanStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = 0;
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<SpanStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SpanStatus): SpanStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* agency.telemetry.v1.SpanStatusCode code */ 1:
                    message.code = reader.int32();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SpanStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* agency.telemetry.v1.SpanStatusCode code = 1; */
        if (message.code !== 0)
            writer.tag(1, WireType.Varint).int32(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.telemetry.v1.SpanStatus
 */
export const SpanStatus = new SpanStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpanEventRecord$Type extends MessageType<SpanEventRecord> {
    constructor() {
        super("agency.telemetry.v1.SpanEventRecord", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 3, name: "attributes", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SpanEventRecord>): SpanEventRecord {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.attributes = {};
        if (value !== undefined)
            reflectionMergePartial<SpanEventRecord>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SpanEventRecord): SpanEventRecord {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 2:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* map<string, string> attributes */ 3:
                    this.binaryReadMap3(message.attributes, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: SpanEventRecord["attributes"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SpanEventRecord["attributes"] | undefined, val: SpanEventRecord["attributes"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.telemetry.v1.SpanEventRecord.attributes");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: SpanEventRecord, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* google.protobuf.Timestamp timestamp = 2; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> attributes = 3; */
        for (let k of globalThis.Object.keys(message.attributes))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.attributes[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.telemetry.v1.SpanEventRecord
 */
export const SpanEventRecord = new SpanEventRecord$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpanLink$Type extends MessageType<SpanLink> {
    constructor() {
        super("agency.telemetry.v1.SpanLink", [
            { no: 1, name: "trace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { len: "32", pattern: "^[0-9a-f]{32}$" } } } },
            { no: 2, name: "span_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { len: "16", pattern: "^[0-9a-f]{16}$" } } } },
            { no: 3, name: "attributes", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "1024" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SpanLink>): SpanLink {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.traceId = "";
        message.spanId = "";
        message.attributes = {};
        if (value !== undefined)
            reflectionMergePartial<SpanLink>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SpanLink): SpanLink {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string trace_id */ 1:
                    message.traceId = reader.string();
                    break;
                case /* string span_id */ 2:
                    message.spanId = reader.string();
                    break;
                case /* map<string, string> attributes */ 3:
                    this.binaryReadMap3(message.attributes, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap3(map: SpanLink["attributes"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SpanLink["attributes"] | undefined, val: SpanLink["attributes"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.telemetry.v1.SpanLink.attributes");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: SpanLink, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string trace_id = 1; */
        if (message.traceId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.traceId);
        /* string span_id = 2; */
        if (message.spanId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.spanId);
        /* map<string, string> attributes = 3; */
        for (let k of globalThis.Object.keys(message.attributes))
            writer.tag(3, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.attributes[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.telemetry.v1.SpanLink
 */
export const SpanLink = new SpanLink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Metric$Type extends MessageType<Metric> {
    constructor() {
        super("agency.telemetry.v1.Metric", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256", pattern: "^[a-z][a-z0-9._]*[a-z0-9]$" } } } },
            { no: 2, name: "type", kind: "enum", T: () => ["agency.telemetry.v1.MetricType", MetricType, "METRIC_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "value", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 5, name: "labels", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128", pattern: "^[a-z][a-z0-9_]*[a-z0-9]$" } }, values: { string: { maxLen: "256" } } } } } },
            { no: 6, name: "unit", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "32" } } } },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<Metric>): Metric {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.type = 0;
        message.value = 0;
        message.labels = {};
        message.unit = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<Metric>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Metric): Metric {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* agency.telemetry.v1.MetricType type */ 2:
                    message.type = reader.int32();
                    break;
                case /* double value */ 3:
                    message.value = reader.double();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 4:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* map<string, string> labels */ 5:
                    this.binaryReadMap5(message.labels, reader, options);
                    break;
                case /* string unit */ 6:
                    message.unit = reader.string();
                    break;
                case /* string description */ 7:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: Metric["labels"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Metric["labels"] | undefined, val: Metric["labels"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.telemetry.v1.Metric.labels");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: Metric, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* agency.telemetry.v1.MetricType type = 2; */
        if (message.type !== 0)
            writer.tag(2, WireType.Varint).int32(message.type);
        /* double value = 3; */
        if (message.value !== 0)
            writer.tag(3, WireType.Bit64).double(message.value);
        /* google.protobuf.Timestamp timestamp = 4; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> labels = 5; */
        for (let k of globalThis.Object.keys(message.labels))
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.labels[k]).join();
        /* string unit = 6; */
        if (message.unit !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.unit);
        /* string description = 7; */
        if (message.description !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.telemetry.v1.Metric
 */
export const Metric = new Metric$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HarnessEvent$Type extends MessageType<HarnessEvent> {
    constructor() {
        super("agency.telemetry.v1.HarnessEvent", [
            { no: 1, name: "harness_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9-]*[a-z0-9]$" } } } },
            { no: 2, name: "event_type", kind: "enum", T: () => ["agency.telemetry.v1.HarnessEventType", HarnessEventType, "HARNESS_EVENT_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "severity", kind: "enum", T: () => ["agency.telemetry.v1.EventSeverity", EventSeverity, "EVENT_SEVERITY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "4096" } } } },
            { no: 5, name: "timestamp", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "node", kind: "message", T: () => NodeID },
            { no: 7, name: "metadata", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "50", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "2048" } } } } } }
        ]);
    }
    create(value?: PartialMessage<HarnessEvent>): HarnessEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.harnessId = "";
        message.eventType = 0;
        message.severity = 0;
        message.message = "";
        message.metadata = {};
        if (value !== undefined)
            reflectionMergePartial<HarnessEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HarnessEvent): HarnessEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string harness_id */ 1:
                    message.harnessId = reader.string();
                    break;
                case /* agency.telemetry.v1.HarnessEventType event_type */ 2:
                    message.eventType = reader.int32();
                    break;
                case /* agency.telemetry.v1.EventSeverity severity */ 3:
                    message.severity = reader.int32();
                    break;
                case /* string message */ 4:
                    message.message = reader.string();
                    break;
                case /* google.protobuf.Timestamp timestamp */ 5:
                    message.timestamp = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.timestamp);
                    break;
                case /* agency.address.v1.NodeID node */ 6:
                    message.node = NodeID.internalBinaryRead(reader, reader.uint32(), options, message.node);
                    break;
                case /* map<string, string> metadata */ 7:
                    this.binaryReadMap7(message.metadata, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap7(map: HarnessEvent["metadata"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof HarnessEvent["metadata"] | undefined, val: HarnessEvent["metadata"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.telemetry.v1.HarnessEvent.metadata");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: HarnessEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string harness_id = 1; */
        if (message.harnessId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.harnessId);
        /* agency.telemetry.v1.HarnessEventType event_type = 2; */
        if (message.eventType !== 0)
            writer.tag(2, WireType.Varint).int32(message.eventType);
        /* agency.telemetry.v1.EventSeverity severity = 3; */
        if (message.severity !== 0)
            writer.tag(3, WireType.Varint).int32(message.severity);
        /* string message = 4; */
        if (message.message !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.message);
        /* google.protobuf.Timestamp timestamp = 5; */
        if (message.timestamp)
            Timestamp.internalBinaryWrite(message.timestamp, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* agency.address.v1.NodeID node = 6; */
        if (message.node)
            NodeID.internalBinaryWrite(message.node, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> metadata = 7; */
        for (let k of globalThis.Object.keys(message.metadata))
            writer.tag(7, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.metadata[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.telemetry.v1.HarnessEvent
 */
export const HarnessEvent = new HarnessEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AlertEvent$Type extends MessageType<AlertEvent> {
    constructor() {
        super("agency.telemetry.v1.AlertEvent", [
            { no: 1, name: "alert_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "rule_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128", pattern: "^[a-z0-9][a-z0-9_-]*[a-z0-9]$" } } } },
            { no: 3, name: "severity", kind: "enum", T: () => ["agency.telemetry.v1.EventSeverity", EventSeverity, "EVENT_SEVERITY_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 4, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 5, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "4096" } } } },
            { no: 6, name: "fired_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 7, name: "resolved", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "resolved_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "labels", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "256" } } } } } },
            { no: 10, name: "annotations", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ }, options: { "buf.validate.field": { map: { maxPairs: "20", keys: { string: { minLen: "1", maxLen: "128" } }, values: { string: { maxLen: "4096" } } } } } }
        ]);
    }
    create(value?: PartialMessage<AlertEvent>): AlertEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.alertId = "";
        message.ruleId = "";
        message.severity = 0;
        message.title = "";
        message.description = "";
        message.resolved = false;
        message.labels = {};
        message.annotations = {};
        if (value !== undefined)
            reflectionMergePartial<AlertEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AlertEvent): AlertEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string alert_id */ 1:
                    message.alertId = reader.string();
                    break;
                case /* string rule_id */ 2:
                    message.ruleId = reader.string();
                    break;
                case /* agency.telemetry.v1.EventSeverity severity */ 3:
                    message.severity = reader.int32();
                    break;
                case /* string title */ 4:
                    message.title = reader.string();
                    break;
                case /* string description */ 5:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Timestamp fired_at */ 6:
                    message.firedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.firedAt);
                    break;
                case /* bool resolved */ 7:
                    message.resolved = reader.bool();
                    break;
                case /* google.protobuf.Timestamp resolved_at */ 8:
                    message.resolvedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.resolvedAt);
                    break;
                case /* map<string, string> labels */ 9:
                    this.binaryReadMap9(message.labels, reader, options);
                    break;
                case /* map<string, string> annotations */ 10:
                    this.binaryReadMap10(message.annotations, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap9(map: AlertEvent["labels"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof AlertEvent["labels"] | undefined, val: AlertEvent["labels"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.telemetry.v1.AlertEvent.labels");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    private binaryReadMap10(map: AlertEvent["annotations"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof AlertEvent["annotations"] | undefined, val: AlertEvent["annotations"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.string();
                    break;
                default: throw new globalThis.Error("unknown map entry field for agency.telemetry.v1.AlertEvent.annotations");
            }
        }
        map[key ?? ""] = val ?? "";
    }
    internalBinaryWrite(message: AlertEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string alert_id = 1; */
        if (message.alertId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.alertId);
        /* string rule_id = 2; */
        if (message.ruleId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.ruleId);
        /* agency.telemetry.v1.EventSeverity severity = 3; */
        if (message.severity !== 0)
            writer.tag(3, WireType.Varint).int32(message.severity);
        /* string title = 4; */
        if (message.title !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.title);
        /* string description = 5; */
        if (message.description !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Timestamp fired_at = 6; */
        if (message.firedAt)
            Timestamp.internalBinaryWrite(message.firedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* bool resolved = 7; */
        if (message.resolved !== false)
            writer.tag(7, WireType.Varint).bool(message.resolved);
        /* google.protobuf.Timestamp resolved_at = 8; */
        if (message.resolvedAt)
            Timestamp.internalBinaryWrite(message.resolvedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* map<string, string> labels = 9; */
        for (let k of globalThis.Object.keys(message.labels))
            writer.tag(9, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.labels[k]).join();
        /* map<string, string> annotations = 10; */
        for (let k of globalThis.Object.keys(message.annotations))
            writer.tag(10, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.LengthDelimited).string(message.annotations[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.telemetry.v1.AlertEvent
 */
export const AlertEvent = new AlertEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RevocationEvent$Type extends MessageType<RevocationEvent> {
    constructor() {
        super("agency.telemetry.v1.RevocationEvent", [
            { no: 1, name: "entity_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } },
            { no: 2, name: "revocation_type", kind: "enum", T: () => ["agency.telemetry.v1.RevocationType", RevocationType, "REVOCATION_TYPE_"], options: { "buf.validate.field": { enum: { definedOnly: true, notIn: [0] } } } },
            { no: 3, name: "tenant", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "64", pattern: "^([a-z0-9][a-z0-9-]*[a-z0-9])?$" } } } },
            { no: 4, name: "reason", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "1024" } } } },
            { no: 5, name: "revoked_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } },
            { no: 6, name: "revoked_by", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "256" } } } }
        ]);
    }
    create(value?: PartialMessage<RevocationEvent>): RevocationEvent {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.entityId = "";
        message.revocationType = 0;
        message.tenant = "";
        message.reason = "";
        message.revokedBy = "";
        if (value !== undefined)
            reflectionMergePartial<RevocationEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RevocationEvent): RevocationEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string entity_id */ 1:
                    message.entityId = reader.string();
                    break;
                case /* agency.telemetry.v1.RevocationType revocation_type */ 2:
                    message.revocationType = reader.int32();
                    break;
                case /* string tenant */ 3:
                    message.tenant = reader.string();
                    break;
                case /* string reason */ 4:
                    message.reason = reader.string();
                    break;
                case /* google.protobuf.Timestamp revoked_at */ 5:
                    message.revokedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.revokedAt);
                    break;
                case /* string revoked_by */ 6:
                    message.revokedBy = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RevocationEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string entity_id = 1; */
        if (message.entityId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.entityId);
        /* agency.telemetry.v1.RevocationType revocation_type = 2; */
        if (message.revocationType !== 0)
            writer.tag(2, WireType.Varint).int32(message.revocationType);
        /* string tenant = 3; */
        if (message.tenant !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.tenant);
        /* string reason = 4; */
        if (message.reason !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.reason);
        /* google.protobuf.Timestamp revoked_at = 5; */
        if (message.revokedAt)
            Timestamp.internalBinaryWrite(message.revokedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string revoked_by = 6; */
        if (message.revokedBy !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.revokedBy);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.telemetry.v1.RevocationEvent
 */
export const RevocationEvent = new RevocationEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportRequest$Type extends MessageType<ExportRequest> {
    constructor() {
        super("agency.telemetry.v1.ExportRequest", [
            { no: 1, name: "batch_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "metrics", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Metric, options: { "buf.validate.field": { repeated: { minItems: "1", maxItems: "10000" } } } },
            { no: 3, name: "export_format", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "32", pattern: "^[a-z0-9_]+$" } } } },
            { no: 4, name: "exported_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ExportRequest>): ExportRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.batchId = "";
        message.metrics = [];
        message.exportFormat = "";
        if (value !== undefined)
            reflectionMergePartial<ExportRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportRequest): ExportRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string batch_id */ 1:
                    message.batchId = reader.string();
                    break;
                case /* repeated agency.telemetry.v1.Metric metrics */ 2:
                    message.metrics.push(Metric.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string export_format */ 3:
                    message.exportFormat = reader.string();
                    break;
                case /* google.protobuf.Timestamp exported_at */ 4:
                    message.exportedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.exportedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string batch_id = 1; */
        if (message.batchId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.batchId);
        /* repeated agency.telemetry.v1.Metric metrics = 2; */
        for (let i = 0; i < message.metrics.length; i++)
            Metric.internalBinaryWrite(message.metrics[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string export_format = 3; */
        if (message.exportFormat !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.exportFormat);
        /* google.protobuf.Timestamp exported_at = 4; */
        if (message.exportedAt)
            Timestamp.internalBinaryWrite(message.exportedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.telemetry.v1.ExportRequest
 */
export const ExportRequest = new ExportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExportResponse$Type extends MessageType<ExportResponse> {
    constructor() {
        super("agency.telemetry.v1.ExportResponse", [
            { no: 1, name: "batch_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "128" } } } },
            { no: 2, name: "metrics_exported", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 3, name: "metrics_failed", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "buf.validate.field": { int32: { gte: 0 } } } },
            { no: 4, name: "export_endpoint", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "512" } } } },
            { no: 5, name: "exported_at", kind: "message", T: () => Timestamp, options: { "buf.validate.field": { required: true } } }
        ]);
    }
    create(value?: PartialMessage<ExportResponse>): ExportResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.batchId = "";
        message.metricsExported = 0;
        message.metricsFailed = 0;
        message.exportEndpoint = "";
        if (value !== undefined)
            reflectionMergePartial<ExportResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExportResponse): ExportResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string batch_id */ 1:
                    message.batchId = reader.string();
                    break;
                case /* int32 metrics_exported */ 2:
                    message.metricsExported = reader.int32();
                    break;
                case /* int32 metrics_failed */ 3:
                    message.metricsFailed = reader.int32();
                    break;
                case /* string export_endpoint */ 4:
                    message.exportEndpoint = reader.string();
                    break;
                case /* google.protobuf.Timestamp exported_at */ 5:
                    message.exportedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.exportedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExportResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string batch_id = 1; */
        if (message.batchId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.batchId);
        /* int32 metrics_exported = 2; */
        if (message.metricsExported !== 0)
            writer.tag(2, WireType.Varint).int32(message.metricsExported);
        /* int32 metrics_failed = 3; */
        if (message.metricsFailed !== 0)
            writer.tag(3, WireType.Varint).int32(message.metricsFailed);
        /* string export_endpoint = 4; */
        if (message.exportEndpoint !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.exportEndpoint);
        /* google.protobuf.Timestamp exported_at = 5; */
        if (message.exportedAt)
            Timestamp.internalBinaryWrite(message.exportedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.telemetry.v1.ExportResponse
 */
export const ExportResponse = new ExportResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HealthCheckRequest$Type extends MessageType<HealthCheckRequest> {
    constructor() {
        super("agency.telemetry.v1.HealthCheckRequest", [
            { no: 1, name: "endpoint", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<HealthCheckRequest>): HealthCheckRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.endpoint = "";
        if (value !== undefined)
            reflectionMergePartial<HealthCheckRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HealthCheckRequest): HealthCheckRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string endpoint */ 1:
                    message.endpoint = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HealthCheckRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string endpoint = 1; */
        if (message.endpoint !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.endpoint);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.telemetry.v1.HealthCheckRequest
 */
export const HealthCheckRequest = new HealthCheckRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HealthCheckResponse$Type extends MessageType<HealthCheckResponse> {
    constructor() {
        super("agency.telemetry.v1.HealthCheckResponse", [
            { no: 1, name: "healthy", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "latency_ms", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/, options: { "buf.validate.field": { int64: { gte: "0" } } } },
            { no: 3, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "buf.validate.field": { string: { maxLen: "2048" } } } }
        ]);
    }
    create(value?: PartialMessage<HealthCheckResponse>): HealthCheckResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.healthy = false;
        message.latencyMs = 0n;
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<HealthCheckResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: HealthCheckResponse): HealthCheckResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool healthy */ 1:
                    message.healthy = reader.bool();
                    break;
                case /* int64 latency_ms */ 2:
                    message.latencyMs = reader.int64().toBigInt();
                    break;
                case /* string error_message */ 3:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: HealthCheckResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool healthy = 1; */
        if (message.healthy !== false)
            writer.tag(1, WireType.Varint).bool(message.healthy);
        /* int64 latency_ms = 2; */
        if (message.latencyMs !== 0n)
            writer.tag(2, WireType.Varint).int64(message.latencyMs);
        /* string error_message = 3; */
        if (message.errorMessage !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message agency.telemetry.v1.HealthCheckResponse
 */
export const HealthCheckResponse = new HealthCheckResponse$Type();
/**
 * @generated ServiceType for protobuf service agency.telemetry.v1.MetricsExporterService
 */
export const MetricsExporterService = new ServiceType("agency.telemetry.v1.MetricsExporterService", [
    { name: "Export", options: {}, I: ExportRequest, O: ExportResponse },
    { name: "HealthCheck", options: {}, I: HealthCheckRequest, O: HealthCheckResponse }
]);
